/* eslint-disable */

/**
 * Artificial timeout, used for retrying requests to prevent a burst of incoming
 * requests. Note: not sure how this will be implemented without creating a new
 * promise, hence the eslint-disable
 *
 * @param durationInMs - How much to wait before resolving the promise
 */
export default async function timeout(durationInMs: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, durationInMs));
}
